import type { Feature } from 'util/stdtypes';
export const ChannelBaseFeature: Feature<any, {}> = {
    name: 'Channels',
    key: 'channelbase',
};
